export class PrintHeader {
    cli_direccion?:string;
    cli_nombre?:string;
    cli_ruc?:string;
    fac_banco?:string;
    fac_referencia?:string;
    fac_direccion?:string;
    fac_efectivo?:string;
    fac_empresa?:string;
    fac_email?:string;
    fac_telefono?:string;
    fac_nombrecom?:string;
    fac_fecha?:string;
    fac_fvcto?:string;
    fac_hora?:string;
    fac_mon?:string;
    fac_tipo_ope?:string;
    fac_igvt?:string;
    fac_ruc?:string;
    fac_cuenta?:string;
    fac_cci?:string;
    fac_tipdoc?:string;
    fac_tarjeta?:string;
    fac_tarjetachq?:string;
    fac_total?:string;
    fac_total_str?:string;
    fac_valorvta?:string;
    fac_ordcompra?:string;
    fac_placa?:string;
    fac_tcambio?:any;
    idfactura?:string;
    numero?:string;
    serie?:string;
    fac_qr?:string;
    fac_cuotas?:any;
    fac_guias?:any;
    fac_personal?:string;
    fac_exonerado?:string;
    fac_inafecto?:string;
    fac_dtrc_tipo?:string;
    fac_dtrc_total?:number;
    fac_dtrc_porcentaje?:number;
    medio_de_pago_dtrc?:string;
    retencion_porcien?:number;
    retencion_total?:number;
    serie_relaci?:string;
    num_relaci?:number;
    motivo?:string;
    fac_metodo_pago?:string;
    constructor(){}
}
